/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path ui
 * @description Scroll anchor
 *
 */
import React from "react";
import { useWindowScroll } from "react-use";
import { useScrollContext } from "./../context/ScrollContextProvider";
const Anchor = (props: { name: string }) => {
  const scrollRef = React.useRef<HTMLDivElement>(null);
  const windowScroll = useWindowScroll();
  const addActive = useScrollContext((state) => state.addElement);
  const setWindowY = useScrollContext((state) => state.setY);
  const setElementPosition = useScrollContext(
    (state) => state.setElementPosition
  );
  React.useEffect(() => {
    let lastRect: any = null;
    let iv = setInterval(() => {
      if (scrollRef.current) {
        const rect = scrollRef.current.getBoundingClientRect();
        if (!lastRect || rect.top !== lastRect.top) {
          setElementPosition(props.name, rect.top);
        }
        lastRect = rect;
      }
    }, 1000);
    return () => {
      clearInterval(iv);
    };
  }, []);
  React.useEffect(() => {
    if (scrollRef.current) {
      addActive({
        el: scrollRef.current,
        key: props.name,
      });
    }
  }, [scrollRef]);
  React.useEffect(() => {
    if (scrollRef.current) {
      setElementPosition(
        props.name,
        scrollRef.current.getBoundingClientRect().top
      );
    }
    setWindowY(windowScroll.y);
  }, [windowScroll.y, scrollRef]);
  return <div ref={scrollRef} />;
};
export default Anchor;
